/* Stacey Forsey — global behaviours */
(function () {
  'use strict';

  // ---- Sticky header on scroll ----
  const header = document.querySelector('[data-sf-header]');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 20) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---- Hamburger overlay ----
  const overlay = document.querySelector('[data-sf-nav]');
  const openers = document.querySelectorAll('[data-sf-nav-open]');
  const closers = document.querySelectorAll('[data-sf-nav-close]');

  const openNav = () => {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sf-nav-open');
    openers.forEach(b => b.setAttribute('aria-expanded', 'true'));
  };
  const closeNav = () => {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sf-nav-open');
    openers.forEach(b => b.setAttribute('aria-expanded', 'false'));
  };

  openers.forEach(b => b.addEventListener('click', openNav));
  closers.forEach(b => b.addEventListener('click', closeNav));
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') closeNav();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeNav();
    });
  }

  // ---- Apply for a seat: pre-fill form + scroll ----
  const applyForm = document.getElementById('sf-apply-form');
  const applyDateDisplay = document.getElementById('sf-apply-date-display');
  const applyDateField = document.getElementById('sf-apply-date');
  const applyProductField = document.getElementById('sf-apply-product');
  const applyVariantField = document.getElementById('sf-apply-variant');

  document.querySelectorAll('[data-sf-apply]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!applyForm) return;
      const date = btn.dataset.date || '';
      const display = btn.dataset.display || date;
      if (applyDateField) applyDateField.value = date;
      if (applyProductField) applyProductField.value = btn.dataset.product || '';
      if (applyVariantField) applyVariantField.value = btn.dataset.variantId || '';
      if (applyDateDisplay) {
        applyDateDisplay.textContent = 'Applying for: ' + display;
        applyDateDisplay.classList.add('is-set');
      }
      const target = document.getElementById('sf-apply');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Move focus to the first input after the scroll settles, but only if it's empty
      // (otherwise we'd disrupt a logged-in customer whose name is prefilled).
      setTimeout(() => {
        const first = document.getElementById('apply-first');
        if (first && !first.value) first.focus({ preventScroll: true });
      }, 600);
    });
  });

  // Stash the date in sessionStorage on submit so we can show it after reload
  if (applyForm) {
    applyForm.addEventListener('submit', () => {
      try {
        const d = applyDateField && applyDateField.value;
        if (d) sessionStorage.setItem('sf-applied-date', d);
      } catch (e) { /* private mode */ }
    });
  }

  // On load: if the thanks message rendered, scroll to it and inject the date
  const thanksEl = document.querySelector('[data-sf-apply-thanks]');
  if (thanksEl) {
    setTimeout(() => {
      const target = document.getElementById('sf-apply') || thanksEl;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
    try {
      const applied = sessionStorage.getItem('sf-applied-date');
      if (applied) {
        const slot = thanksEl.querySelector('[data-sf-applied-date]');
        if (slot) {
          slot.textContent = 'Your application was for: ' + applied;
          slot.hidden = false;
        }
        sessionStorage.removeItem('sf-applied-date');
      }
    } catch (e) { /* private mode */ }
  }

  // ---- External links open in new tab + carry rel=noopener/noreferrer ----
  // Catches all sociaks, mailto stays in same tab, internal links untouched.
  const ownHost = location.hostname;
  const markExternal = (root) => {
    root.querySelectorAll('a[href]').forEach((a) => {
      if (a.dataset.sfExtChecked) return;
      const href = a.getAttribute('href') || '';
      if (!href || href.startsWith('#')) return;
      if (href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
        a.dataset.sfExtChecked = '1';
        return;
      }
      let isExternal = false;
      if (href.startsWith('//')) {
        isExternal = !href.startsWith('//' + ownHost);
      } else if (/^https?:\/\//i.test(href)) {
        try {
          const u = new URL(href, location.href);
          isExternal = u.hostname && u.hostname !== ownHost;
        } catch (e) { /* ignore */ }
      }
      if (isExternal) {
        if (!a.hasAttribute('target')) a.setAttribute('target', '_blank');
        const existingRel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
        for (const t of ['noopener', 'noreferrer']) {
          if (!existingRel.includes(t)) existingRel.push(t);
        }
        a.setAttribute('rel', existingRel.join(' '));
      }
      a.dataset.sfExtChecked = '1';
    });
  };
  markExternal(document);
  // Re-run when Shopify section editor or other JS injects new markup
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((node) => {
        if (node.nodeType === 1) markExternal(node);
      });
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // ---- Scroll fade-in ----
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('.sf-fade').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.sf-fade').forEach(el => el.classList.add('is-visible'));
  }

  // ---- Hero video sound toggle ----
  // The hero clip autoplays muted (browser requirement); this button lets a
  // visitor unmute to hear Stacey's narration. Delegated so it survives the
  // section editor re-rendering the hero.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.sf-page__hero-sound');
    if (!btn) return;
    const hero = btn.closest('.sf-page__hero');
    const v = hero && hero.querySelector('.sf-video video');
    if (!v) return;
    v.muted = !v.muted;
    if (!v.muted) {
      try { v.currentTime = 0; } catch (err) { /* ignore */ }
      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }
    const on = !v.muted;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', String(on));
    btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
    const label = btn.querySelector('.sf-page__hero-sound-label');
    if (label) label.textContent = on ? 'Sound off' : 'Sound on';
  });
})();
